<template>
  <div
      id="app"
      :style="{
      '--theme': verConfig.theme || '',
      '--nav-background': navBg || '',
      '--font': isApple
        ? `'Myriad', 'Bogle', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'`
        : 'Myriad',
    }"
  >
    <router-view/>
    <WelfareDialog
        v-model="welfareDialogShow"
        :content="welfareDialogContent"
        :msgId="messageInfo.id"
        @read="read"
        :next="nextmsg"
    />
    <Floatball :size="60" @click="toChatroom" v-if="showFloatBall">
      <div class="float_ball_wrap">
        <img src="./assets/icon/float_ball_msg.png" alt=""/>
      </div>
    </Floatball>
    <div v-show="false">{{ systemConfig }}</div>
  </div>
</template>
<script>
import {Dialog, Toast} from "vant";
import Tabbar from "./components/newTabbar";
import Floatball from "./components/floatBall.vue";
import WelfareDialog from "./components/welfareDialog.vue";
import {$get, $post} from "@/utils/request";
import qs from "qs";
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      active: 0,
      welfareDialogShow: false,
      welfareDialogContent: "",
      messageInfo: {},
      msgList: [],
      nextmsg: false,
      showFloatBall: false,
      thirdToken: "",
      isApple: false,
    };
  },
  components: {
    Tabbar,
    WelfareDialog,
    Floatball,
  },
  created() {
    // if (!localStorage.getItem('user-info')) {
    //   if (this.$router.history.current.name !== 'login') {
    //     // this.$router.replace('login')
    //     this.$router.push('login')
    //   }
    // }
    const version =
        /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    this.isApple = version;
    sessionStorage.setItem("version-dialog-show", true);
    if (!localStorage.getItem("version")) {
      localStorage.setItem("version", "1.0.7");
    }
  },
  computed: {
    needCache() {
      return !!sessionStorage.getItem("cache")
    },
    navBg() {
      const navBGConfig = this.verConfig.navBg;
      if (Array.isArray(navBGConfig)) {
        return `linear-gradient(to ${
            this.verConfig.navBGToBottom ? "bottom" : "right"
        }, ${navBGConfig[0]}, ${navBGConfig[1]})`;
      }
      return navBGConfig;
    },
    ...mapGetters(["systemConfig"]),
  },
  methods: {
    toChatroom() {
      this.$router.push("/ChatList");
    },
    onChange() {
      window.console.log(123);
    },
    goto(path = ``) {
      this.$router.push(path);
    },

    read(next = false, nextParams = {}) {
      if (nextParams && Object.keys(nextParams).length)
        this.messageInfo = nextParams;

      // this.msgList.shift();
      if (!!this.msgList[0].nextmsg && !next) {
        this.welfareDialogContent = this.msgList[0].nextmsg;
        if (!next) {
          this.nextmsg = true;
        } else {
          this.nextmsg = false;
        }
        this.welfareDialogShow = true;
      }
      // if (this.msgList.length) {
      //   this.welfareDialogContent = this.msgList[0].content;
      //   this.messageInfo = this.msgList[0];
      //   this.welfareDialogShow = true;
      // }
    },
    async getMessage() {
      Toast.loading();
      try {
        const res = await $get("/users/message", {
          perPage: 999,
          status: "unread",
          notify: 1,
        });
        Toast.clear();
        const {ret, msg, data} = res.data;
        if (!data.total) return;
        if (!!data.lists.length) {
          this.welfareDialogShow = true;
          if (!!this.messageInfo.id && this.messageInfo.id == data.lists[0].id)
            return;
          this.welfareDialogContent = data.lists[0].content;
          this.messageInfo = data.lists[0];
          this.msgList = data.lists;
        }
      } catch (error) {
        Toast.clear();
      }
    },
  },
  watch: {
    $route(to, from) {
      const pages = this.verConfig.tabbar
          ? this.verConfig.tabbar.pages || []
          : [];
      const currentPage = this.$route;
      const currentPath = currentPage.path;
      const pathArr = currentPath.split("/");
      const pageIndex = pages.findIndex(
          (item) => item.pagePath === pathArr[pathArr.length - 1]
      );
      // this.$store.commit("SET_ACTIVE", pageIndex);
      /** -----------------------上面是tabbar---------------------------- */
      const token = localStorage.getItem("token");
      if (
          to.path == "/ChatList" ||
          to.path == "/ChatRoom" ||
          !token ||
          !this.verConfig.hasChat
      ) {
        this.showFloatBall = false;
      } else {
        this.showFloatBall = true;
      }
      if (
          (to.path === "/registrasi") |
          (to.path === "/login") |
          !localStorage.getItem("token")
      )
        return;
      this.getMessage();
    },
    systemConfig(val) {
      if (!val.appurl_android) return;
      const {v} = qs.parse(val.appurl_android.split("?")[1]);
      if (v > this.verConfig.appVersion) {
        Dialog.alert({
          title: "",
          message: this.$t("Hint.updateText"),
          // cancelButtonText: this.$t("Button.cancle"),
          confirmButtonText: this.$t("Button.confirm"),
        })
            .then(() => {
              // on confirm
              location.href = val.appurl_android;
            })
            .catch(() => {

            });
      }
    },
  },
};

window.onload = function () {
  document.addEventListener("touchstart", function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener("gesturestart", function (event) {
    event.preventDefault();
  });
};
</script>
<style>
#app {
  width: 100%;
  max-width: 750px;
  height: 100%;
  margin: 0 auto;
}

* {
  /* font-family: 'Bogle','Helvetica Neue','Helvetica','Arial','sans-serif'; */
  /* font-family: 'Myriad' !important; */
  letter-spacing: 1px;
  font-weight: 400;
}

*:not([class*="icon"]):not([class*="iconfont"]):not(.fa):not(.fas):not(i) {
  font-family: var(--font, "Myriad");
}

body {
  font-size: 16px;
  color: var(--color-text);
  background-color: var(--page-background);
  -webkit-font-smoothing: antialiased;
}

:root {
  --trade-green: #01BD8D;
  --trade-red: #F55555;
  /* --nav-background: #0073e4; */
}

/* a {
  position: fixed;
  top: -1000px;
} */
.van-nav-bar {
  background: var(--nav-background);
  max-width: 750px;
  margin: 0 auto;
  left: 50% !important;
  transform: translateX(-50%);
  box-shadow: inset 0 -1px var(--color-primary-border);
}

.van-nav-bar .van-icon {
  color: var(--color-primary-strong) !important;
}

.van-nav-bar__content {
  background: var(--nav-background);
}

.van-sticky--fixed {
  width: 100%;
  max-width: 750px;
  left: 50% !important;
  transform: translateX(-50%);
}

.van-nav-bar__title {
  color: var(--color-text) !important;
}

.wrap {
  min-height: 100vh;
  background-color: var(--page-background);
  overflow: hidden;
  max-width: 750px;
}
</style>
<style lang="less" scoped>
.float_ball_wrap {
  @border_size: 4px;
  border: @border_size solid var(--color-primary-border);
  background: var(--color-primary-gradient);
  height: calc(var(--size) - @border_size * 2); // 这个size是来自floatBall组件的
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  > img {
    width: 60%;
    height: 60%;
  }
}
</style>
